export function formatCount(n: number): string {
  if (n >= 100000000) {
    return `${(n / 100000000).toFixed(1)}亿`;
  }
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  return String(n);
}

export function formatDate(time: string): string {
  return time.slice(0, 10);
}

export function formatDateTime(time: string): string {
  return time.replace(" ", " ");
}

export function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: "smooth" });
}